// DETELE THIS ONCE WE MIGRATE TO react@18:
// `event.code` is available since react@17+ and we are still using react@16 on funnel.
// React PR for reference: https://github.com/facebook/react/pull/18287/files

const eventCode = event => {
  return event?.code || event?.nativeEvent?.code;
};
export default eventCode;
//# sourceMappingURL=event-code.js.map